// LoginForm.tsx
import React from "react";
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Stack,
    FormErrorMessage,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import useLogin from "../hooks/useLogin";

type FormData = {
    username: string;
    password: string;
};

const LoginForm: React.FC = () => {
    const {
        handleSubmit,
        register,
        formState: { errors, isSubmitting },
    } = useForm<FormData>();
    const { onSubmit } = useLogin();

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={4}>
                <FormControl isInvalid={!!errors.username}>
                    <FormLabel htmlFor="username">Email</FormLabel>
                    <Input
                        id="username"
                        type="email"
                        {...register("username", {
                            required: "Email is required",
                            pattern: {
                                value: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
                                message: "Invalid email format",
                            },
                        })}
                    />
                    <FormErrorMessage>{errors.username?.message}</FormErrorMessage>
                </FormControl>

                <FormControl isInvalid={!!errors.password}>
                    <FormLabel htmlFor="password">Password</FormLabel>
                    <Input
                        id="password"
                        type="password"
                        {...register("password", {
                            required: "Password is required",
                        })}
                    />
                    <FormErrorMessage>{errors.password?.message}</FormErrorMessage>
                </FormControl>

                <Button colorScheme="blue" isLoading={isSubmitting} type="submit">
                    Login
                </Button>
            </Stack>
        </form>
    );
};

export default LoginForm;
